import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { SystemActions } from './system.action';

export type SystemState = {
  isLoading: boolean;
  isMapLoading: boolean;
  isLoadingCount: number;
  isMapLoadingCount: number;
};

const initialState: SystemState = {
  isLoading: false,
  isLoadingCount: 0,
  isMapLoading: false,
  isMapLoadingCount: 0,
};

export const SystemReducer = reducerWithInitialState<SystemState>(initialState)
  .case(SystemActions.setIsLoading, (state, payload) => ({
    ...state,
    isLoading: payload,
  }))
  .case(SystemActions.setIsLoadingCount, (state, payload) => {
    const count = state.isLoadingCount + payload;
    return ({
      ...state,
      isLoadingCount: count < 0 ? 0 : count,
    });
  })
  .case(SystemActions.setIsMapLoading, (state, payload) => ({
    ...state,
    isMapLoading: payload,
  }))
  .case(SystemActions.setIsMapLoadingCount, (state, payload) => {
    const count = state.isMapLoadingCount + payload;
    return ({
      ...state,
      isMapLoadingCount: count < 0 ? 0 : count,
    });
  })
  .case(SystemActions.resetState, () => initialState);
